import { ReactComponent as AutoRenewal } from "./svg/auto-renewal.svg";

export const IconAutoRenewal = () => <AutoRenewal />;
